import  React from 'react'
import * as H from 'history'
import { ISupportSpinner } from '../../../shared/Ajax'
import { IField, validateFields } from '../../../shared/fields'
import EditableTable from '../../../shared/EditableTable'
import { MilestoneReportModel } from '../../../models/MilestoneReportModel'
import { MilestoneModel } from '../../../models/MilestoneModel'
import { Columns } from '../../../shared/EditableTable/Model'


export interface Props {
    onChange: { (changes: Partial<MilestoneModel>, callback?: { (): any }): any }
    initData: { columns: Columns[], data: any, skipReset: boolean, model: MilestoneReportModel, modelPath: string, propertyName: string }
    uniqueSelectSelection?: boolean
    selectedCategories?: string[]
    rowAddedHandler?: { (): any }
    rowRemovedHandler?: { (index:number) : any}
    maximumRows?: number
    tableName?: string
}

export interface State {
    loading: boolean
}

export class MilestoneReportEditable extends React.Component<Props, State> implements
    IField {
    constructor(props: Props) {
        super(props)

        this.state = {
            loading: false,
        }
    }

    validate(callback: { (res: boolean): any }, focus?: boolean) {
        callback && callback(false)
    }

    toggleSpinner(on: boolean, callback: { (): any }): void {
        this.setState({ loading: on }, callback)
    }

    render() {
        const { onChange, initData, uniqueSelectSelection, selectedCategories
            , rowAddedHandler
            , rowRemovedHandler
            , maximumRows
            , tableName } = this.props
        return (
            <>
                <div className="form-item">
                    <EditableTable
                        initialData={initData}
                        onChange={onChange}
                        uniqueSelectSelection={uniqueSelectSelection}
                        selectedCategories={selectedCategories}
                        rowAddedHandler={rowAddedHandler}
                        rowRemovedHandler={rowRemovedHandler}
                        maximumRows={maximumRows}
                        tableName={tableName}
                    />
                </div>
            </>
        )
    }
}
